module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.measurementUnitLists,
      "paginator": true,
      "rows": 10,
      "data-key": "id"
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(slotProps.index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "field": "name",
      "filterField": "name",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Short Name",
      "field": "shortName",
      "filterField": "shortName",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Description Name",
      "field": "description",
      "filterField": "description",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editMeasurementUnit(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteMeasurement
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587a2fdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/item/measurementUnitList.vue
// module id = 2243
// module chunks = 0